import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconApply = ({ color = 'var(--color-primary-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 8.68182L5.13636 12.8182L15.7727 1" stroke={color} strokeWidth="1.5"/>
        </svg>
    </div>
);

export default IconApply;
